import { useCallback, useRef } from 'react';
import { scrollTo } from 'utils';

export default function useScrollIntoView() {
  const container = useRef<HTMLDivElement>(null);

  const scrollToStart = useCallback(
    () =>
      scrollTo({
        top: container.current.offsetTop,
        left: container.current.offsetLeft,
      }),
    [],
  );

  return [container, scrollToStart] as const;
}
